import { render } from "./BaseTableIncludableData.vue?vue&type=template&id=18cf2f74&scoped=true"
import script from "./BaseTableIncludableData.vue?vue&type=script&lang=js"
export * from "./BaseTableIncludableData.vue?vue&type=script&lang=js"

import "./BaseTableIncludableData.vue?vue&type=style&index=0&id=18cf2f74&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18cf2f74"]])

export default __exports__